import resourcesConfig from "./config";
import resourcesFactory from "./factory";
import bookingsResource from "./bookings/bookings.module";
import loginResource from "./login/login.module";
import logoutResource from "./logout/logout.module";
import cityResource from "./city/city.module";
import userResource from "./user/user.module";
import promotionResource from "./promotion/promotion.module";
import corporateResource from "./corporate/corporate.module";
import corporateInvoiceItemResource from "./corporateInvoiceItem/corporateInvoiceItem.module";
import topupResource from "./topup/topup.module";
import busResource from "./bus/bus.module";
import bustypeResource from "./bustype/bustype.module";
import companyResource from "./company/company.module";
import captainResource from "./captain/captain.module";
import stationResource from "./station/station.module";
import districtResource from "./district/district.module";
import routeResource from "./route/route.module";
import rideResource from "./ride/ride.module";
import transactionResource from "./transaction/transaction.module";
import scheduleResource from "./schedule/schedule.module";
import subscriptionResource from "./subscription/subscription.module";
import dispatcherResource from "./dispatcher/dispatcher.module";
import universalResource from "./universal/universal.module";
import ticketResource from "./ticket/ticket.module";
import reportResource from "./report/report.module";
import ratingResource from "./rating/rating.module";
import basicPlanResource from "./basicPlan/basicPlan.module";
import backupPlanResource from "./backupPlan/backupPlan.module";
import captainPlanResource from "./captainPlan/captainPlan.module";
import deductionPlanResource from "./deductionPlan/deductionPlan.module";
import invoiceResource from "./invoice/invoice.module";
import invoiceItemResource from "./invoiceItem/invoiceItem.module";
import creditsResource from "./credits/credits.module";
import holidayResource from "./holiday/holiday.module";
import backupResource from "./backup/backup.module";
import backupRecommendationResource from "./backupRecommendation/backupRecommendation.module";
import backupScheduleResource from "./backupSchedule/backupSchedule.module";
import reservationResource from "./reservation/reservation.module";
import paymentCycleResource from "./paymentCycle/paymentCycle.module";
import rougenaResource from "./rougena/rougena.module";
import loanResource from "./loan/loan.module";
import tagResource from "./tag/tag.module";
import currencyResource from "./currency/currency.module";
import countryResource from "./country/country.module";
import userpromotionResource from "./userpromotion/userpromotion.module";
import redirectorResource from "./redirector/redirector.module";
import eventsResource from "./events/events.module";
import travelRequestsResource from "./travelRequests/travelRequests.module";
import privateBusRequestsResource from "./privateBusRequests/privateBusRequests.module";
import privateBusPricingResource from "./privateBusPricing/privateBusPricing.module";
import bulkBonusesResource from "./bulkbonuses/bulkbonuses.module";
import contractsResource from "./contracts/contracts.module";
import mockResource from "./mock/mock.module";
import contractorResource from "./contractor/contractor.module";
import contractorsResource from "./contractors/contractors.module";
import packagesResource from "./packages/packages.module";
import contractorInvoiceResource from "./contractorInvoice/contractorInvoice.module";
import authorizationResource from "./authorization/authorization.module";
import fileDownloadResource from "./fileDownload/fileDownload.module";
import variablePlanResource from "./variablePlan/variablePlan.module";
import roleResource from "./role/role.module";
import bulkScriptsResource from "./bulkScripts/bulkScripts.module";
import corporateTransportationSubmissionsResource from "./corporateTransportationSubmissions/corporateTransportationSubmissions.module";
import fulfillmentPlanResource from "./fulfillmentPlan/fulfillmentPlan.module";
import rescueReasonsResource from "./rescueReasons/rescueReasons.module";
import invoiceItemTypeResource from "./invoiceItemType/invoiceItemType.module";
import captainAppResource from "./captainApp/captainApp.module";
import paymentMethodResource from "./paymentMethod/paymentMethod.module";
import paymentCycleConfigurationsResource from "./paymentCycleConfigurations/paymentCycleConfigurations.module";
import fineReimbursementResource from "./fineReimbursement/fineReimbursement.module";
import biddingCampaignsResource from "./biddingCampaigns/biddingCampaigns.module";
import boardingCheckinResource from "./boardingCheckin/boardingCheckin.module";

const resourcesModule = angular
  .module("app.resources", [
    bookingsResource.name,
    loginResource.name,
    logoutResource.name,
    cityResource.name,
    userResource.name,
    promotionResource.name,
    corporateResource.name,
    corporateInvoiceItemResource.name,
    topupResource.name,
    busResource.name,
    bustypeResource.name,
    companyResource.name,
    captainResource.name,
    stationResource.name,
    districtResource.name,
    routeResource.name,
    rideResource.name,
    transactionResource.name,
    scheduleResource.name,
    subscriptionResource.name,
    dispatcherResource.name,
    universalResource.name,
    ticketResource.name,
    reportResource.name,
    ratingResource.name,
    basicPlanResource.name,
    backupPlanResource.name,
    captainPlanResource.name,
    deductionPlanResource.name,
    invoiceResource.name,
    backupRecommendationResource.name,
    invoiceItemResource.name,
    creditsResource.name,
    holidayResource.name,
    backupResource.name,
    backupScheduleResource.name,
    reservationResource.name,
    paymentCycleResource.name,
    rougenaResource.name,
    loanResource.name,
    tagResource.name,
    currencyResource.name,
    countryResource.name,
    userpromotionResource.name,
    redirectorResource.name,
    eventsResource.name,
    travelRequestsResource.name,
    privateBusRequestsResource.name,
    privateBusPricingResource.name,
    bulkBonusesResource.name,
    contractsResource.name,
    mockResource.name,
    contractorResource.name,
    contractorsResource.name,
    packagesResource.name,
    contractorInvoiceResource.name,
    fileDownloadResource.name,
    variablePlanResource.name,
    authorizationResource.name,
    fileDownloadResource.name,
    bulkScriptsResource.name,
    roleResource.name,
    corporateTransportationSubmissionsResource.name,
    fulfillmentPlanResource.name,
    rescueReasonsResource.name,
    invoiceItemTypeResource.name,
    captainAppResource.name,
    paymentMethodResource.name,
    paymentCycleConfigurationsResource.name,
    fineReimbursementResource.name,
    biddingCampaignsResource.name,
    boardingCheckinResource.name,
  ])
  .factory("authenticationInterceptor", resourcesFactory)
  .config(resourcesConfig);

export default resourcesModule;



// WEBPACK FOOTER //
// ./src/resources/index.js